export default __webpack_public_path__ + "static/media/ranking-level-dropped-step3.3e625177.png";